"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoVipPointMultiplierToJSON = exports.GoVipPointMultiplierFromJSONTyped = exports.GoVipPointMultiplierFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GoVipPointMultiplierFromJSON(json) {
    return GoVipPointMultiplierFromJSONTyped(json, false);
}
exports.GoVipPointMultiplierFromJSON = GoVipPointMultiplierFromJSON;
function GoVipPointMultiplierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'action': (0, _1.GoVipActionTypeFromJSON)(json['action']),
        'startDate': !(0, runtime_1.exists)(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !(0, runtime_1.exists)(json, 'endDate') ? undefined : json['endDate'],
        'multiplier': json['multiplier'],
    };
}
exports.GoVipPointMultiplierFromJSONTyped = GoVipPointMultiplierFromJSONTyped;
function GoVipPointMultiplierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'action': (0, _1.GoVipActionTypeToJSON)(value.action),
        'startDate': value.startDate,
        'endDate': value.endDate,
        'multiplier': value.multiplier,
    };
}
exports.GoVipPointMultiplierToJSON = GoVipPointMultiplierToJSON;
